import React, { useEffect, useState } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { get } from 'services';
import Spinner from 'react-bootstrap/Spinner';

const ParentBaseSelect = ({errors, touched, handleChange, values, label, name, url, md, titleInBold, displayName = 'nombre', optionValue = 'id', parentId = null, onParentChange, hasDependency = true, parentName, filterBy, onSelected }) => {
    const [data, setData] = useState([]);
    const [displayLoading, setDisplayLoading] = useState(false);
    
    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        if (!hasDependency) {
            setDisplayLoading(true);
            get(url).then(response => {
                seedData(response.data);
                setDisplayLoading(false);
            });
        } else if (parentId && parentId != 0 && parentId != 'Seleccione') {
            setDisplayLoading(true);
            get(url + `?$filter=${filterBy} eq ${parentId}`).then(response => {
                seedData(response.data);
                //values[name] = null;
                setDisplayLoading(false);
            });
        } else {
            seedData(null);
            // limpiar en cascada
            values[name] = null;
            if (onParentChange) {
                onParentChange(null)
            }
        }
    }

    const seedData = (response) => {
        let data = [
            {
                [optionValue]: null,
                [displayName]: 'Seleccione'
            }
        ]
        if (response) {
            data = [
                ...data,
                ...response
            ]
        }
        setData(data);
    }

    useEffect(() => {
        if (onParentChange) {
            onParentChange(values[name])
        }
        if(onSelected) {
            const result = data.find(x => x[optionValue] == values[name]);
            if (result) {
                onSelected(result)
            }
        }
    }, [values[name]])

    useEffect(() => {
        fetchData();
    }, [parentId])
    
    return (
        <>
            <Form.Group as={Col} md={md} controlId={"validationFormik_" + name}>
                <Form.Label> 
                    {   
                        titleInBold
                        ? <b> { label } </b>
                        : label 
                    }
                </Form.Label>
                {' '}
                {
                    displayLoading && 
                    <Spinner
                        as="span"
                        size="sm"
                        role="status"
                        animation="grow"
                        aria-hidden="true"
                    />
                }
                <Form.Control
                    name={name}
                    value={values[name]}
                    onChange={handleChange}
                    //isValid={touched[name] && !errors[name]}
                    isInvalid={!!errors[name]}
                    as="select"
                    custom
                >
                    {
                        data.map(option => {
                            return (
                                <option key={option[optionValue]} value={option[optionValue]}>{option[displayName]}</option>
                            )
                        })
                    }
                </Form.Control>
            </Form.Group>
        </>
    )
}

export default ParentBaseSelect;